import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { ErrorPage, Layout, LoadingPage } from './components/Layout';
import { usePath } from './router';
import type { PublicSnapshot, SiteData } from './types';
import { ManagerPage } from './pages/ManagerPage';
import { ContactPage, EventsPage, GalleryPage, HomeExtras, HomePage, JoinPage, NotFoundPage, PlayersPage, PracticePage, PrivacyPage, SafeguardingPage, SponsorsPage, TermsPage, TournamentsPage } from './pages/PublicPages';

export default function App() {
  const path=usePath(); const [data,setData]=useState<SiteData|null>(null); const [snapshot,setSnapshot]=useState<PublicSnapshot|null>(null); const [error,setError]=useState(false);
  const load=useCallback(async()=>{setError(false);try{const [site,app]=await Promise.all([api.site(),api.snapshot().catch(()=>null)]);setData(site);setSnapshot(app);}catch{setError(true);}},[]);
  useEffect(()=>{void load();},[load]);
  useEffect(()=>{document.title=`${routeTitle(path)} | Forfar Youth Darts Club`;},[path]);
  if(error)return <Layout path={path}><ErrorPage retry={load}/></Layout>;
  if(!data)return <Layout path={path}><LoadingPage/></Layout>;
  let page;
  switch(path){
    case '/': page=<><HomePage data={data} snapshot={snapshot}/><HomeExtras data={data}/></>;break;
    case '/tournaments': page=<TournamentsPage snapshot={snapshot}/>;break;
    case '/sponsors': page=<SponsorsPage data={data}/>;break;
    case '/events': page=<EventsPage events={data.events}/>;break;
    case '/gallery': page=<GalleryPage photos={data.photos}/>;break;
    case '/players': page=<PlayersPage data={data} snapshot={snapshot}/>;break;
    case '/practice': page=<PracticePage data={data}/>;break;
    case '/contact': page=<ContactPage data={data}/>;break;
    case '/join': page=<JoinPage data={data}/>;break;
    case '/safeguarding': page=<SafeguardingPage data={data}/>;break;
    case '/privacy': page=<PrivacyPage/>;break;
    case '/terms': page=<TermsPage/>;break;
    case '/manager': page=<ManagerPage data={data} snapshot={snapshot} onData={setData}/>;break;
    default: page=<NotFoundPage/>;
  }
  return <Layout path={path}>{page}</Layout>;
}

function routeTitle(path:string){return ({'/':'Home','/tournaments':'Events & Results','/sponsors':'Sponsors','/events':'Events','/gallery':'Gallery','/players':'Club Players','/practice':'Practice Pack','/contact':'Contact Us','/join':'Join Us','/safeguarding':'Safeguarding','/privacy':'Privacy Notice','/terms':'Terms & Copyright','/manager':'Club Manager'} as Record<string,string>)[path]||'Page Not Found'}
